import { CLEAR_INLINE_ERRORS, HIDE_LOADER, SET_INLINE_ERROR, SET_PAGE_ERROR, SHOW_LOADER, SHOW_SUPPORT_MODAL, SET_FORM_IS_SUBMITTING, SET_AUTO_REG_MODE, SET_GLOBAL_LOADERS, } from "./types";
export var showLoader = function (loadingText) { return ({
    type: SHOW_LOADER,
    payload: loadingText,
}); };
export var hideLoader = function () { return ({
    type: HIDE_LOADER,
}); };
export var setShowSupportModal = function (show) {
    if (show === void 0) { show = true; }
    return ({
        type: SHOW_SUPPORT_MODAL,
        payload: show,
    });
};
export var setPageError = function (pageError) { return ({
    type: SET_PAGE_ERROR,
    payload: pageError,
}); };
export var setInlineError = function (errors) { return ({
    type: SET_INLINE_ERROR,
    payload: errors,
}); };
export var clearInlineErrors = function (keysToClear) { return ({
    type: CLEAR_INLINE_ERRORS,
    payload: keysToClear,
}); };
export var setFormIsSubmitting = function (isSubmitting) { return ({
    type: SET_FORM_IS_SUBMITTING,
    payload: isSubmitting,
}); };
export var setAutoRegMode = function (isSubmitting) { return ({
    type: SET_AUTO_REG_MODE,
    payload: isSubmitting,
}); };
export var setGlobalLoaders = function (loaders) { return ({
    type: SET_GLOBAL_LOADERS,
    payload: loaders,
}); };
